module.exports = __webpack_public_path__ + "static/media/title_eng.d552d325.png";